// Get all top-level mobile menu summary links
document.querySelectorAll('summary.mobile-link').forEach(summary => {
  // Get the URL from data-url
  const url = summary.getAttribute('data-url');

  // Find the + icon inside this summary
  const toggleIcon = summary.querySelector('.hdt-btn-open-sub');

  // Click event on the summary itself
  summary.addEventListener('click', function(e) {
    // If the click is on the + icon, do nothing (allow dropdown toggle)
    if (toggleIcon && (toggleIcon.contains(e.target))) {
      return; // normal toggle
    }

    // Otherwise, navigate to the link URL
    if (url) {
      window.location.href = url;
    }

    // Prevent the <summary> default toggle
    e.preventDefault();
  });
});